/**
 * HTML do editor rich text → texto plano.
 *
 * Descrições de produto e de catálogo são gravadas em HTML (o editor é TipTap). Onde o
 * destino NÃO renderiza HTML — uma lista, um dropdown de busca, um `title` de tooltip — a
 * tag aparece crua para o operador. Este helper é a conversão.
 *
 * Onde o destino RENDERIZA (`dangerouslySetInnerHTML`, como o detalhe do produto na loja),
 * não use: ali o HTML é o conteúdo.
 */
export function stripHtml(html?: string | null): string {
    if (!html) return ''
    return html
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>/gi, '\n\n')
        .replace(/<\/li>/gi, '\n')
        .replace(/<li[^>]*>/gi, '• ')
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/\n{3,}/g, '\n\n')
        .trim()
}

/** Igual ao `stripHtml`, mas numa linha só — para resumo, truncamento e tooltip. */
export function stripHtmlInline(html?: string | null): string {
    return stripHtml(html).replace(/\s+/g, ' ').trim()
}
